import MainContainer from "../../components/container/MainContainer";

const ProvincialReports = () => {
  return <MainContainer>ProvincialReports</MainContainer>;
};

export default ProvincialReports;
